import { ChainId } from './util/chains';
import { AuctionAddressETHMainnet, DOBAddressETHMainnet, DOBStakingPoolAddressETHMainnet, DistributionsAddressETHMainnet, GoldGeregeAddressETHMainnet, HODLStakingPoolRewarderAddressETHMainnet, HODLStakingPoolsAddressETHMainnet, MatchingMarketAddressETHMainnet, OptionFactoryAddressETHMainnet, SilverGeregeAddressETHMainnet, StakingPoolRewarderAddressETHMainnet, StakingPoolsAddressETHMainnet, USDCAddressETHMainnet, UniswapV3FactoryAddressETHMainnet, WBTCAddressETHMainnet, WETHAddressETHMainnet, bHODLAddressETHMainnet, bHODLRewarderAddressETHMainnet, uHODLAddressETHMainnet, uHODLRewarderAddressETHMainnet, } from './eth-mainnet';
import { AuctionAddressEthSepolia, DOBAddressEthSepolia, DOBStakingPoolAddressEthSepolia, DistributionsAddressEthSepolia, GoldGeregeAddressEthSepolia, HODLStakingPoolRewarderAddressEthSepolia, HODLStakingPoolsAddressEthSepolia, MatchingMarketAddressEthSepolia, OptionFactoryAddressEthSepolia, SilverGeregeAddressEthSepolia, StakingPoolRewarderAddressEthSepolia, StakingPoolsAddressEthSepolia, 
// TokenKeeperAddressEthSepolia,
TestTokenPoolAddressEthSepolia, USDCAddressEthSepolia, WBTCAddressEthSepolia, WETHAddressEthSepolia, bHODLAddressEthSepolia, bHODLRewarderAddressEthSepolia, uHODLAddressEthSepolia, uHODLRewarderAddressEthSepolia, } from './eth-sepolia';
import { AuctionAddressScrollSepolia, eDOBAddressScrollSepolia, DOBStakingPoolAddressScrollSepolia, DistributionsAddressScrollSepolia, GoldGeregeAddressScrollSepolia, HODLStakingPoolRewarderAddressScrollSepolia, HODLStakingPoolsAddressScrollSepolia, MatchingMarketAddressScrollSepolia, OptionFactoryAddressScrollSepolia, SilverGeregeAddressScrollSepolia, StakingPoolRewarderAddressScrollSepolia, StakingPoolsAddressScrollSepolia, TestTokenPoolAddressScrollSepolia, 
// TokenKeeperAddressScrollSepolia,
USDCAddressScrollSepolia, WETHAddressScrollSepolia, eHODLAddressScrollSepolia, eHODLRewarderAddressScrollSepolia, uHODLAddressScrollSepolia, uHODLRewarderAddressScrollSepolia, } from './scroll-sepolia';
import { initContractABIs } from './abi';
import { ethers } from 'ethers';
export const AuctionAddressEnum = {
    [ChainId.ETH_MAINNET]: AuctionAddressETHMainnet,
    [ChainId.ETH_SEPOLIA]: AuctionAddressEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: AuctionAddressScrollSepolia,
};
export const sellTokenHODLAddressEnum = {
    [ChainId.ETH_MAINNET]: bHODLAddressETHMainnet,
    [ChainId.ETH_SEPOLIA]: bHODLAddressEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: eHODLAddressScrollSepolia,
};
export const sellTokenHODLRewarderAddressEnum = {
    [ChainId.ETH_MAINNET]: bHODLRewarderAddressETHMainnet,
    [ChainId.ETH_SEPOLIA]: bHODLRewarderAddressEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: eHODLRewarderAddressScrollSepolia,
};
export const USDCAddressEnum = {
    [ChainId.ETH_MAINNET]: USDCAddressETHMainnet,
    [ChainId.ETH_SEPOLIA]: USDCAddressEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: USDCAddressScrollSepolia,
};
export const DistributionsAddressEnum = {
    [ChainId.ETH_MAINNET]: DistributionsAddressETHMainnet,
    [ChainId.ETH_SEPOLIA]: DistributionsAddressEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: DistributionsAddressScrollSepolia,
};
export const DOBAddressEnum = {
    [ChainId.ETH_MAINNET]: DOBAddressETHMainnet,
    [ChainId.ETH_SEPOLIA]: DOBAddressEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: eDOBAddressScrollSepolia,
};
export const DOBStakingPoolAddressEnum = {
    [ChainId.ETH_MAINNET]: DOBStakingPoolAddressETHMainnet,
    [ChainId.ETH_SEPOLIA]: DOBStakingPoolAddressEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: DOBStakingPoolAddressScrollSepolia,
};
export const GoldGeregeAddressEnum = {
    [ChainId.ETH_MAINNET]: GoldGeregeAddressETHMainnet,
    [ChainId.ETH_SEPOLIA]: GoldGeregeAddressEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: GoldGeregeAddressScrollSepolia,
};
export const HODLStakingPoolRewarderAddressEnum = {
    [ChainId.ETH_MAINNET]: HODLStakingPoolRewarderAddressETHMainnet,
    [ChainId.ETH_SEPOLIA]: HODLStakingPoolRewarderAddressEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: HODLStakingPoolRewarderAddressScrollSepolia,
};
export const HODLStakingPoolsAddressEnum = {
    [ChainId.ETH_MAINNET]: HODLStakingPoolsAddressETHMainnet,
    [ChainId.ETH_SEPOLIA]: HODLStakingPoolsAddressEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: HODLStakingPoolsAddressScrollSepolia,
};
export const OptionFactoryAddressEnum = {
    [ChainId.ETH_MAINNET]: OptionFactoryAddressETHMainnet,
    [ChainId.ETH_SEPOLIA]: OptionFactoryAddressEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: OptionFactoryAddressScrollSepolia,
};
export const StakingPoolRewarderAddressEnum = {
    [ChainId.ETH_MAINNET]: StakingPoolRewarderAddressETHMainnet,
    [ChainId.ETH_SEPOLIA]: StakingPoolRewarderAddressEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: StakingPoolRewarderAddressScrollSepolia,
};
export const StakingPoolsAddressEnum = {
    [ChainId.ETH_MAINNET]: StakingPoolsAddressETHMainnet,
    [ChainId.ETH_SEPOLIA]: StakingPoolsAddressEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: StakingPoolsAddressScrollSepolia,
};
export const SilverGeregeAddressEnum = {
    [ChainId.ETH_MAINNET]: SilverGeregeAddressETHMainnet,
    [ChainId.ETH_SEPOLIA]: SilverGeregeAddressEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: SilverGeregeAddressScrollSepolia,
};
export const TestTokenPoolAddressEnum = {
    [ChainId.ETH_MAINNET]: ethers.ZeroAddress,
    [ChainId.ETH_SEPOLIA]: TestTokenPoolAddressEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: TestTokenPoolAddressScrollSepolia,
};
export const uHODLAddressEnum = {
    [ChainId.ETH_MAINNET]: uHODLAddressETHMainnet,
    [ChainId.ETH_SEPOLIA]: uHODLAddressEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: uHODLAddressScrollSepolia,
};
export const uHODLRewarderAddressEnum = {
    [ChainId.ETH_MAINNET]: uHODLRewarderAddressETHMainnet,
    [ChainId.ETH_SEPOLIA]: uHODLRewarderAddressEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: uHODLRewarderAddressScrollSepolia,
};
export const WETHAddressEnum = {
    [ChainId.ETH_MAINNET]: WETHAddressETHMainnet,
    [ChainId.ETH_SEPOLIA]: WETHAddressEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: WETHAddressScrollSepolia,
};
export const sellTokenAddressEnum = {
    [ChainId.ETH_MAINNET]: WBTCAddressETHMainnet,
    [ChainId.ETH_SEPOLIA]: WBTCAddressEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: WETHAddressScrollSepolia,
};
export const MatchingMarketAddressEnum = {
    [ChainId.ETH_MAINNET]: MatchingMarketAddressETHMainnet,
    [ChainId.ETH_SEPOLIA]: MatchingMarketAddressEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: MatchingMarketAddressScrollSepolia,
};
export const UniswapV3FactoryAddressEnum = {
    [ChainId.ETH_MAINNET]: UniswapV3FactoryAddressETHMainnet,
    [ChainId.ETH_SEPOLIA]: '',
    [ChainId.SCROLL_SEPOLIA]: '',
};
export let AuctionAddress = AuctionAddressEnum[ChainId.ETH_MAINNET];
export let sellTokenHODLAddress = sellTokenHODLAddressEnum[ChainId.ETH_MAINNET];
export let sellTokenHODLRewarderAddress = sellTokenHODLRewarderAddressEnum[ChainId.ETH_MAINNET];
export let USDCAddress = USDCAddressEnum[ChainId.ETH_MAINNET];
export let DistributionsAddress = DistributionsAddressEnum[ChainId.ETH_MAINNET];
export let DOBAddress = DOBAddressEnum[ChainId.ETH_MAINNET];
export let DOBStakingPoolAddress = DOBStakingPoolAddressEnum[ChainId.ETH_MAINNET];
export let GoldGeregeAddress = GoldGeregeAddressEnum[ChainId.ETH_MAINNET];
export let HODLStakingPoolRewarderAddress = HODLStakingPoolRewarderAddressEnum[ChainId.ETH_MAINNET];
export let HODLStakingPoolsAddress = HODLStakingPoolsAddressEnum[ChainId.ETH_MAINNET];
export let OptionFactoryAddress = OptionFactoryAddressEnum[ChainId.ETH_MAINNET];
export let StakingPoolRewarderAddress = StakingPoolRewarderAddressEnum[ChainId.ETH_MAINNET];
export let TestTokenPoolAddress = TestTokenPoolAddressEnum[ChainId.ETH_MAINNET];
export let StakingPoolsAddress = StakingPoolsAddressEnum[ChainId.ETH_MAINNET];
export let SilverGeregeAddress = SilverGeregeAddressEnum[ChainId.ETH_MAINNET];
export let uHODLAddress = uHODLAddressEnum[ChainId.ETH_MAINNET];
export let uHODLRewarderAddress = uHODLRewarderAddressEnum[ChainId.ETH_MAINNET];
export let WETHAddress = WETHAddressEnum[ChainId.ETH_MAINNET];
export let sellTokenAddress = sellTokenAddressEnum[ChainId.ETH_MAINNET];
export let MatchingMarketAddress = MatchingMarketAddressEnum[ChainId.ETH_MAINNET];
export let UniswapV3FactoryAddress = UniswapV3FactoryAddressEnum[ChainId.ETH_MAINNET];
export const initContractAddresses = (chainId) => {
    AuctionAddress = AuctionAddressEnum[chainId];
    sellTokenHODLAddress = sellTokenHODLAddressEnum[chainId];
    sellTokenHODLRewarderAddress = sellTokenHODLRewarderAddressEnum[chainId];
    USDCAddress = USDCAddressEnum[chainId];
    DistributionsAddress = DistributionsAddressEnum[chainId];
    DOBAddress = DOBAddressEnum[chainId];
    DOBStakingPoolAddress = DOBStakingPoolAddressEnum[chainId];
    GoldGeregeAddress = GoldGeregeAddressEnum[chainId];
    HODLStakingPoolRewarderAddress = HODLStakingPoolRewarderAddressEnum[chainId];
    HODLStakingPoolsAddress = HODLStakingPoolsAddressEnum[chainId];
    OptionFactoryAddress = OptionFactoryAddressEnum[chainId];
    StakingPoolRewarderAddress = StakingPoolRewarderAddressEnum[chainId];
    StakingPoolsAddress = StakingPoolsAddressEnum[chainId];
    SilverGeregeAddress = SilverGeregeAddressEnum[chainId];
    TestTokenPoolAddress = TestTokenPoolAddressEnum[chainId];
    uHODLAddress = uHODLAddressEnum[chainId];
    uHODLRewarderAddress = uHODLRewarderAddressEnum[chainId];
    WETHAddress = WETHAddressEnum[chainId];
    sellTokenAddress = sellTokenAddressEnum[chainId];
    MatchingMarketAddress = MatchingMarketAddressEnum[chainId];
    UniswapV3FactoryAddress = UniswapV3FactoryAddressEnum[chainId];
};
export { initContractABIs };
export * from './util';
//# sourceMappingURL=index.js.map